module.exports = __webpack_public_path__ + "img/sicoob.83fc1f7e.svg";